import angular from 'angular';
import todayOrBefore from './today-or-before';
import todayOrLater from './today-or-later';
import afterDate from './after-date';
import beforeDate from './before-date';
import timeFieldNowOrLater from './time-field-now-or-later';

let fieldValidatorsModule = angular.module('app.fieldValidators', [])

.directive('sbTodayOrBefore', todayOrBefore)
.directive('sbTodayOrLater', todayOrLater)
.directive('sbAfterDate', afterDate)
.directive('sbBeforeDate', beforeDate)
.directive('sbTimeFieldNowOrLater', timeFieldNowOrLater)

.name;

export default fieldValidatorsModule;



// WEBPACK FOOTER //
// ./client/app/common/field-validators/field-validators.js